import enterpriseApi from './axios/enterprise-api';

const ENTERPRISE_ID = 'e14fe3e5-7b49-4354-b169-faa1b466d3aa';

export const getEnterpriseInfo = async () => {
  const response = await enterpriseApi.readUnique(ENTERPRISE_ID);
  return response.data;
};
